export const LOCAL_STORAGE_KEYS = {
  LANG: "lang",
  TOKEN: "token",
};
